export const appPageTransition = {"name":"page","mode":"out-in"}

export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"hid":"description","name":"description","content":"Vrede maken we samen!"}],"link":[{"rel":"preconnect","href":"//www.google-analytics.com"},{"rel":"preconnect","href":"//www.googletagmanager.com"}],"style":[{"hid":"css-variables","children":":root { --font-family-primary:Aktiv Grotesk, sans-serif;--font-size-xxs:0.75rem;--font-size-xs:0.875rem;--font-size-sm:1rem;--font-size-md:1.125rem;--font-size-lg:1.25rem;--font-size-xl:1.375rem;--font-size-2xl:1.5rem;--font-size-3xl:1.75rem;--font-size-4xl:2rem;--font-size-5xl:2.5rem;--font-size-6xl:3rem;--font-size-7xl:4rem;--font-weight-primary-normal:400;--font-weight-primary-medium:500;--font-weight-primary-bold:700;--lineHeight-xs:.9;--lineHeight-sm:1;--lineHeight-md:1.1;--lineHeight-lg:1.2;--lineHeight-xl:1.4;--grid-side-gap-sm:var(--grid-gap-sm);--grid-side-gap-md:var(--grid-gap-md);--grid-side-gap-lg:var(--grid-gap-lg);--grid-gap-sm:var(--spacing-md);--grid-gap-md:var(--spacing-lg);--grid-gap-lg:var(--spacing-4xl);--grid-maxWidth-page:90rem;--grid-maxWidth-content:25rem;--grid-maxWidth-content-wide:45rem;--grid-maxLargeScreenWidth-page:120rem;--grid-maxLargeScreenWidth-content:40rem;--grid-maxLargeScreenWidth-content-wide:75rem;--navbar-width:2.625rem;--navbar-height:2.5rem;--navbar-border-width:.625rem;--spacing-2xs:.3125rem;--spacing-xs:.625rem;--spacing-sm:.75rem;--spacing-md:1rem;--spacing-lg:1.25rem;--spacing-xl:2rem;--spacing-2xl:2.5rem;--spacing-3xl:3rem;--spacing-4xl:4rem;--color-darkest:#000;--color-lightest:#fff;--color-dark:#1E1E1E;--color-light:#EAECF0;--color-gray:#eaecf0;--color-red:#EA072B;--color-orange:#FF9900;--color-magenta:#FF00FF;--color-blue:#0072FF;--color-dark-blue:#000C8C;--color-green:#00FF84;--transition-timing-slow:1s;--transition-timing-medium:500ms;--transition-timing-fast:150ms;--transition-timingFunction-in:cubic-bezier(0.4, 0, 1, 1);--transition-timingFunction-out:cubic-bezier(0, 0, 0.2, 1);--transition-timingFunction-in-out:cubic-bezier(0.4, 0, 0.2, 1);--transition-fast:var(--transition-timing-fast) 0ms var(--transition-timingFunction-in);--transition-medium:var(--transition-timing-medium) 0ms var(--transition-timingFunction-in);--transition-slow:var(--transition-timing-slow) 0ms var(--transition-timingFunction-in); }","type":"text/css"}],"script":[],"noscript":[],"title":"Het Nationaal Fonds voor Vrede, Vrijheid en Veteranenzorg (vfonds)"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const resetAsyncDataToUndefined = false

export const nuxtDefaultErrorValue = undefined

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false